import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Contact = ({ onContactClick }) => {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4">
              Get in Touch
            </h2>
            <div className="w-24 h-1 bg-[#2d8b8b] mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Ready to protect your brand? Contact us today for a free consultation with our trademark experts.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <Card className="p-6 text-center hover:shadow-lg transition-shadow duration-300 border-t-4 border-[#2d8b8b]">
              <div className="w-14 h-14 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-semibold text-[#1e3a5f] mb-2">Address</h3>
              <p className="text-sm text-gray-600">{businessInfo.address}</p>
            </Card>

            <Card className="p-6 text-center hover:shadow-lg transition-shadow duration-300 border-t-4 border-[#2d8b8b]">
              <div className="w-14 h-14 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-semibold text-[#1e3a5f] mb-2">Phone</h3>
              <a
                href={`tel:${businessInfo.phone}`}
                className="text-sm text-gray-600 hover:text-[#2d8b8b] transition-colors"
              >
                {businessInfo.phone}
              </a>
            </Card>

            <Card className="p-6 text-center hover:shadow-lg transition-shadow duration-300 border-t-4 border-[#2d8b8b]">
              <div className="w-14 h-14 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-semibold text-[#1e3a5f] mb-2">Email</h3>
              <a
                href={`mailto:${businessInfo.email}`}
                className="text-sm text-gray-600 hover:text-[#2d8b8b] transition-colors break-all"
              >
                {businessInfo.email}
              </a>
            </Card>

            <Card className="p-6 text-center hover:shadow-lg transition-shadow duration-300 border-t-4 border-[#2d8b8b]">
              <div className="w-14 h-14 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-semibold text-[#1e3a5f] mb-2">Business Hours</h3>
              <p className="text-sm text-gray-600">Mon - Fri: 9AM - 6PM</p>
              <p className="text-sm text-gray-600">Sat - Sun: Closed</p>
            </Card>
          </div>

          <div className="text-center">
            <Card className="inline-block p-8 bg-gradient-to-br from-gray-50 to-white">
              <h3 className="text-2xl font-bold text-[#1e3a5f] mb-4">
                Ready to Get Started?
              </h3>
              <p className="text-gray-600 mb-6 max-w-md">
                Click the button below to fill out our contact form and begin your trademark registration journey.
              </p>
              <Button
                onClick={onContactClick}
                size="lg"
                className="bg-[#2d8b8b] hover:bg-[#236b6b] text-white px-8"
              >
                Start Your Application
              </Button>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
